/**
 * Initialize Ids. Makes it easier
 * to work with the data in the editor.
 */
export function initializeId(places) {
    if (places) {
        for (const place of places) {
            if (place?.info) {
                for (const info of place.info) {
                    if (!info.id) info.id = info.index;
                }
            }
            if (place?.suggestions) {
                for (const suggestion of place.suggestions) {
                    if (!suggestion.id) suggestion.id = suggestion.index;
                }
            }
        }
    }

    return places;
}

/**
 * Group places by name.
 */

export const group = (xs) => {
    if (!xs) return [];
    const places = [];
    const reducedObj = xs.reduce((rv, x) => {
        (rv[x['place']] = rv[x['place']] || []).push(x);
        return rv;
    }, {});

    let index = 0;
    for (const [key, value] of Object.entries(reducedObj)) {
        const place = { name: key, index: index++, suggestions: [], info: [] };
        for (const item of value) {
            item.checked = false;
            if (item.type === 'suggestions') place.suggestions.push(item);
            else place.info.push(item);
        }
        places.push(place);
    }
    return places;
};

/**
 * Ungroup places by name.
 */

export const ungroup = (places) => {
    if (!places || !places?.[0]) return [];
    if (!places?.[0].hasOwnProperty('suggestions')) return places;

    const items = [];
    for (const place of places) {
        for (const suggestion of place.suggestions) {
            items.push({ ...suggestion, place: place.name });
        }
        for (const info of place.info) {
            items.push({ ...info, place: place.name });
        }
    }
    return items;
};

/**
 * Extract attractions from suggestions.
 */

export const extractAttractions = (suggestions, name) => {
    if (!suggestions || suggestions.length === 0) return [];
    const totalAttractions = [];
    suggestions.forEach((suggestion) => {
        const attractions = suggestion.attractions?.map((attr) => {
            return {
                ...attr,
                place: name,
                filterId: suggestion.filterId
            };
        });
        totalAttractions.push(...attractions);
    });
    return totalAttractions;
};

/**
 * Check if first entity has the id or importId equal to the second param.
 */

export const sameIdOrImportId = (el, id) => {
    return el.id === id || el.importId === id;
};

/**
 * Filter data from useless fields.
 */

export const filterUselessFields = (data) => {
    const newData = { ...data };
    Object.entries(newData).forEach(([key, value]) => {
        if (typeof value === 'object') delete newData[key];
    });
    if (newData.totalPrice === undefined) delete newData.totalPrice;
    delete newData.intro;
    delete newData.cover;
    delete newData.jingle;
    delete newData.id;
    delete newData.importId;
    delete newData.type;
    delete newData.dayIndex;
    delete newData.infoId;
    delete newData.planIndex;
    delete newData.suggestionId;
    return newData;
};

export const deletePlaceToRegenerate = (places, placeFilters, onDelete, shouldRegenerateLocked) => {
    const ungroupedPlaces = ungroup(places);
    placeFilters.forEach((pf) => {
        const placesToDelete = ungroupedPlaces.filter((p) => pf.name === p.place);
        if (pf.regenerate) {
            placesToDelete.forEach((p) => {
                const index = ungroupedPlaces.findIndex((place) => place.id === p.id);
                if (index !== -1 && (!p.locked || shouldRegenerateLocked)) {
                    ungroupedPlaces.splice(index, 1);
                    onDelete(pf.name, p.type, p.id);
                }
            });
        } else {
            placesToDelete.forEach((p) => {
                if (!pf.filters.some((filter) => filter.id === p.filterId)) {
                    const index = ungroupedPlaces.findIndex((place) => place.id === p.id);
                    if (index !== -1 && (!p.locked || shouldRegenerateLocked)) {
                        ungroupedPlaces.splice(index, 1);
                        onDelete(pf.name, p.type, p.id);
                    }
                }
            });
        }
    });
};
